import type { ChatSettings } from '../types';

export const defaults: Partial<ChatSettings> = {
  buttonBorderRadius: 24,
  bubbleIcon: {
    url: 'https://static.elfsight.com/icons/app-chats-telegram-chat.svg'
  },
  welcomeMessage: 'Hi there 👋 <br><br>How can I help you?',
  buttonText: 'Chat on Telegram',
  headerBackgroundColor: 'rgb(255, 255, 255)',
  buttonColor: { type: 'native', color: 'rgb(0, 136, 204)' },
  bubbleBackgroundColor: 'rgb(0, 136, 204)',
  bubbleIconColor: 'rgb(255, 255, 255)',
  chatWallpaperMulticolor: {
    type: 'native',
    color: 'rgb(255, 255, 255)'
  },
  messageBackgroundColor: 'rgb(255, 255, 255)',
  align: 'right'
};
